import type { FunctionComponent } from 'react';
import { Fragment } from 'react';

export const notFoundTitle = 'Not Found';

type NotFoundProps = {
  // Disables the meta title. Default to false.
  noTitle?: boolean;
};

export const NotFound: FunctionComponent<NotFoundProps> = ({ noTitle }) => (
  <Fragment>
    {!noTitle && <title>{notFoundTitle}</title>}
    <p className="font-bold m-2">
      No page was found here. It’s possible that you don’t have permission to view this page.
    </p>
  </Fragment>
);
